import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MonthlyMISMain from "./monthlyMis";
export default function MonthlyMIS() {
  return (
    <DashboardLayout>
      <MonthlyMISMain />
    </DashboardLayout>
  );
}
